import api from "../../../utils/api";

export const readTenantBySlug = async (slug) => {
  const res = await api.get(`/tenants/by-slug/${encodeURIComponent(slug)}`, {
    validateStatus: (status) => status === 200 || status === 404,
  });
  return res.status === 404 ? null : res.data;
};

export const readCurrentTenant = async () => {
  const res = await api.get("/tenants/current");
  return res.data;
};

export const updateCurrentTenant = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.put("/tenants/current", payload);
  return res.data;
};

export const updateTenantLogo = async ({ file }) => {
  if (!file) throw new Error("Missing file");

  const formData = new FormData();
  formData.append("file", file);

  const res = await api.post("/tenants/current/icon", formData);
  return res.data;
};
